/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptWinbackRequest,
  CancellationRequestResponse,
  ConfirmResubscribeRequest,
  ConfirmResubscribeResponse,
  CreateCancellationRequestRequest,
  DeclineWinbackRequest,
  EnhancedSubscriptionResponse,
  HTTPValidationError,
  PaymentMethodUpdateResponse,
  PaywallContextResponse,
  ResubscribeRequest,
  ResubscribeResponse,
  SetupIntentResponse,
  UpdatePaymentMethodRequest,
  WinbackPricingResponse
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get the current subscription for the authenticated member.

Returns subscription with enhanced status:
- If no cancellation request exists: returns original status
- If active cancellation request exists: returns status as "cancellation_pending"
- If resolved cancellation request exists: returns original status
 * @summary Get Subscriptions
 */
export const getSubscriptionsV1SubscriptionsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<EnhancedSubscriptionResponse>(
      {url: `/v1/subscriptions`, method: 'GET', signal
    },
      );
    }
  

export const getGetSubscriptionsV1SubscriptionsGetQueryKey = () => {
    return [`/v1/subscriptions`] as const;
    }

    
export const getGetSubscriptionsV1SubscriptionsGetQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionsV1SubscriptionsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>> = ({ signal }) => getSubscriptionsV1SubscriptionsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSubscriptionsV1SubscriptionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>>
export type GetSubscriptionsV1SubscriptionsGetQueryError = unknown


export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Subscriptions
 */

export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSubscriptionsV1SubscriptionsGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create Cancellation Request
 */
export const createCancellationRequestV1SubscriptionCancellationRequestsPost = (
    createCancellationRequestRequest: CreateCancellationRequestRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<CancellationRequestResponse>(
      {url: `/v1/subscription-cancellation-requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCancellationRequestRequest, signal
    },
      );
    }
  


export const getCreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, TError,{data: CreateCancellationRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, TError,{data: CreateCancellationRequestRequest}, TContext> => {

const mutationKey = ['createCancellationRequestV1SubscriptionCancellationRequestsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, {data: CreateCancellationRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  createCancellationRequestV1SubscriptionCancellationRequestsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>>
    export type CreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationBody = CreateCancellationRequestRequest
    export type CreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationError = HTTPValidationError

    /**
 * @summary Create Cancellation Request
 */
export const useCreateCancellationRequestV1SubscriptionCancellationRequestsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, TError,{data: CreateCancellationRequestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>,
        TError,
        {data: CreateCancellationRequestRequest},
        TContext
      > => {

      const mutationOptions = getCreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Get pricing information for the winback discount offer.

Returns original price, discount amount, and final price after discount.
Only available for subscriptions with pending cancellation requests that
haven't previously used the winback offer.
 * @summary Get Winback Pricing
 */
export const getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet = (
    stripeSubscriptionId: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<WinbackPricingResponse>(
      {url: `/v1/subscription-cancellation-requests/${stripeSubscriptionId}/winback-pricing`, method: 'GET', signal
    },
      );
    }
  

export const getGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryKey = (stripeSubscriptionId?: string,) => {
    return [`/v1/subscription-cancellation-requests/${stripeSubscriptionId}/winback-pricing`] as const;
    }

    
export const getGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryOptions = <TData = Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError = HTTPValidationError>(stripeSubscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryKey(stripeSubscriptionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>> = ({ signal }) => getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet(stripeSubscriptionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(stripeSubscriptionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryResult = NonNullable<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>>
export type GetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryError = HTTPValidationError


export function useGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet<TData = Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError = HTTPValidationError>(
 stripeSubscriptionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>,
          TError,
          Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet<TData = Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError = HTTPValidationError>(
 stripeSubscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>,
          TError,
          Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet<TData = Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError = HTTPValidationError>(
 stripeSubscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Winback Pricing
 */

export function useGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet<TData = Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError = HTTPValidationError>(
 stripeSubscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryOptions(stripeSubscriptionId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Accept the winback discount offer.

Applies the discount coupon to the subscription and updates the
cancellation request outcome to WONBACK. The subscription will continue
with the discount applied to the next billing cycle.
 * @summary Accept Winback Offer
 */
export const acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost = (
    acceptWinbackRequest: AcceptWinbackRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<CancellationRequestResponse>(
      {url: `/v1/subscription-cancellation-requests/accept-winback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptWinbackRequest, signal
    },
      );
    }
  


export const getAcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>, TError,{data: AcceptWinbackRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>, TError,{data: AcceptWinbackRequest}, TContext> => {

const mutationKey = ['acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>, {data: AcceptWinbackRequest}> = (props) => {
          const {data} = props ?? {};

          return  acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPostMutationResult = NonNullable<Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>>
    export type AcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPostMutationBody = AcceptWinbackRequest
    export type AcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPostMutationError = HTTPValidationError

    /**
 * @summary Accept Winback Offer
 */
export const useAcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>, TError,{data: AcceptWinbackRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>,
        TError,
        {data: AcceptWinbackRequest},
        TContext
      > => {

      const mutationOptions = getAcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Decline the winback discount offer and proceed with cancellation.

Disables auto-renewal on the subscription and updates the cancellation
request outcome to CANCELLED. The subscription will end at the current
period end.
 * @summary Decline Winback Offer
 */
export const declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost = (
    declineWinbackRequest: DeclineWinbackRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<CancellationRequestResponse>(
      {url: `/v1/subscription-cancellation-requests/decline-winback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: declineWinbackRequest, signal
    },
      );
    }
  


export const getDeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>, TError,{data: DeclineWinbackRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>, TError,{data: DeclineWinbackRequest}, TContext> => {

const mutationKey = ['declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>, {data: DeclineWinbackRequest}> = (props) => {
          const {data} = props ?? {};

          return  declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPostMutationResult = NonNullable<Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>>
    export type DeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPostMutationBody = DeclineWinbackRequest
    export type DeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPostMutationError = HTTPValidationError

    /**
 * @summary Decline Winback Offer
 */
export const useDeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>, TError,{data: DeclineWinbackRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>,
        TError,
        {data: DeclineWinbackRequest},
        TContext
      > => {

      const mutationOptions = getDeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Create a SetupIntent for collecting a new payment method.

This endpoint is used when a user needs to update their payment method,
typically after a failed payment or when their card is expiring.

The returned client_secret should be used with Stripe.js confirmSetup()
to collect and confirm the new payment method.
 * @summary Create Setup Intent
 */
export const createSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPost = (
    subscriptionId: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<SetupIntentResponse>(
      {url: `/v1/subscriptions/${subscriptionId}/setup-intent`, method: 'POST', signal
    },
      );
    }
  


export const getCreateSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPost>>, TError,{subscriptionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPost>>, TError,{subscriptionId: string}, TContext> => {

const mutationKey = ['createSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPost>>, {subscriptionId: string}> = (props) => {
          const {subscriptionId} = props ?? {};

          return  createSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPost(subscriptionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPostMutationResult = NonNullable<Awaited<ReturnType<typeof createSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPost>>>
    
    export type CreateSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPostMutationError = HTTPValidationError

    /**
 * @summary Create Setup Intent
 */
export const useCreateSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPost>>, TError,{subscriptionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPost>>,
        TError,
        {subscriptionId: string},
        TContext
      > => {

      const mutationOptions = getCreateSetupIntentV1SubscriptionsSubscriptionIdSetupIntentPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Update subscription payment method and retry any failed invoice.

This endpoint completes the payment recovery flow:
1. Retrieves the confirmed SetupIntent to get the new payment method
2. Updates the subscription's default payment method
3. Retries the latest unpaid invoice if present

The setup_intent_id must be for a SetupIntent that has been confirmed
by the frontend using Stripe.js confirmSetup().

Returns 402 Payment Required if the invoice payment fails (card declined).
 * @summary Update Payment Method
 */
export const updatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatch = (
    subscriptionId: string,
    updatePaymentMethodRequest: UpdatePaymentMethodRequest,
 ) => {
      
      
      return customCatchBackendFetcher<PaymentMethodUpdateResponse>(
      {url: `/v1/subscriptions/${subscriptionId}/payment-method`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePaymentMethodRequest
    },
      );
    }
  


export const getUpdatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatch>>, TError,{subscriptionId: string;data: UpdatePaymentMethodRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatch>>, TError,{subscriptionId: string;data: UpdatePaymentMethodRequest}, TContext> => {

const mutationKey = ['updatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatch>>, {subscriptionId: string;data: UpdatePaymentMethodRequest}> = (props) => {
          const {subscriptionId,data} = props ?? {};

          return  updatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatch(subscriptionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatch>>>
    export type UpdatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatchMutationBody = UpdatePaymentMethodRequest
    export type UpdatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatchMutationError = HTTPValidationError

    /**
 * @summary Update Payment Method
 */
export const useUpdatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatch>>, TError,{subscriptionId: string;data: UpdatePaymentMethodRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatch>>,
        TError,
        {subscriptionId: string;data: UpdatePaymentMethodRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePaymentMethodV1SubscriptionsSubscriptionIdPaymentMethodPatchMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Get all context needed to display the paywall modal.

This endpoint returns minimal data needed for paywall display without
user-level access checks. It consolidates multiple API calls into one
to avoid 403 errors for cancelled users.

Returns:
    - subscription_status: Current subscription status from catch-backend DB
    - was_trial: Whether subscription ever had a trial period
    - has_labs_processed: Whether user has any processed lab results
    - is_in_dunning: Whether there's an active payment failure dunning cycle
    - flow_type: 'update_payment_method' or 'create_subscription'
    - price: Current membership pricing
 * @summary Get Paywall Context
 */
export const getPaywallContextV1SubscriptionsPaywallContextGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<PaywallContextResponse>(
      {url: `/v1/subscriptions/paywall-context`, method: 'GET', signal
    },
      );
    }
  

export const getGetPaywallContextV1SubscriptionsPaywallContextGetQueryKey = () => {
    return [`/v1/subscriptions/paywall-context`] as const;
    }

    
export const getGetPaywallContextV1SubscriptionsPaywallContextGetQueryOptions = <TData = Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaywallContextV1SubscriptionsPaywallContextGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>> = ({ signal }) => getPaywallContextV1SubscriptionsPaywallContextGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPaywallContextV1SubscriptionsPaywallContextGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>>
export type GetPaywallContextV1SubscriptionsPaywallContextGetQueryError = unknown


export function useGetPaywallContextV1SubscriptionsPaywallContextGet<TData = Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>,
          TError,
          Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaywallContextV1SubscriptionsPaywallContextGet<TData = Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>,
          TError,
          Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaywallContextV1SubscriptionsPaywallContextGet<TData = Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Paywall Context
 */

export function useGetPaywallContextV1SubscriptionsPaywallContextGet<TData = Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaywallContextV1SubscriptionsPaywallContextGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPaywallContextV1SubscriptionsPaywallContextGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new subscription for a cancelled user.

This endpoint is used by the paywall to create a new subscription when
a user with a cancelled subscription wants to re-subscribe.

Returns a client_secret that the frontend uses to confirm the payment
with Stripe Elements.
 * @summary Create Resubscription
 */
export const createResubscriptionV1SubscriptionsResubscribePost = (
    resubscribeRequest: ResubscribeRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<ResubscribeResponse>(
      {url: `/v1/subscriptions/resubscribe`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resubscribeRequest, signal
    },
      );
    }
  


export const getCreateResubscriptionV1SubscriptionsResubscribePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResubscriptionV1SubscriptionsResubscribePost>>, TError,{data: ResubscribeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createResubscriptionV1SubscriptionsResubscribePost>>, TError,{data: ResubscribeRequest}, TContext> => {

const mutationKey = ['createResubscriptionV1SubscriptionsResubscribePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResubscriptionV1SubscriptionsResubscribePost>>, {data: ResubscribeRequest}> = (props) => {
          const {data} = props ?? {};

          return  createResubscriptionV1SubscriptionsResubscribePost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateResubscriptionV1SubscriptionsResubscribePostMutationResult = NonNullable<Awaited<ReturnType<typeof createResubscriptionV1SubscriptionsResubscribePost>>>
    export type CreateResubscriptionV1SubscriptionsResubscribePostMutationBody = ResubscribeRequest
    export type CreateResubscriptionV1SubscriptionsResubscribePostMutationError = HTTPValidationError

    /**
 * @summary Create Resubscription
 */
export const useCreateResubscriptionV1SubscriptionsResubscribePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResubscriptionV1SubscriptionsResubscribePost>>, TError,{data: ResubscribeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createResubscriptionV1SubscriptionsResubscribePost>>,
        TError,
        {data: ResubscribeRequest},
        TContext
      > => {

      const mutationOptions = getCreateResubscriptionV1SubscriptionsResubscribePostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Confirm a resubscription after frontend payment confirmation.

This is called after the frontend successfully confirms the payment
with Stripe.js. We verify the subscription is now active and update
our local database.
 * @summary Confirm Resubscription
 */
export const confirmResubscriptionV1SubscriptionsResubscribeConfirmPost = (
    confirmResubscribeRequest: ConfirmResubscribeRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<ConfirmResubscribeResponse>(
      {url: `/v1/subscriptions/resubscribe/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmResubscribeRequest, signal
    },
      );
    }
  


export const getConfirmResubscriptionV1SubscriptionsResubscribeConfirmPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmResubscriptionV1SubscriptionsResubscribeConfirmPost>>, TError,{data: ConfirmResubscribeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmResubscriptionV1SubscriptionsResubscribeConfirmPost>>, TError,{data: ConfirmResubscribeRequest}, TContext> => {

const mutationKey = ['confirmResubscriptionV1SubscriptionsResubscribeConfirmPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmResubscriptionV1SubscriptionsResubscribeConfirmPost>>, {data: ConfirmResubscribeRequest}> = (props) => {
          const {data} = props ?? {};

          return  confirmResubscriptionV1SubscriptionsResubscribeConfirmPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmResubscriptionV1SubscriptionsResubscribeConfirmPostMutationResult = NonNullable<Awaited<ReturnType<typeof confirmResubscriptionV1SubscriptionsResubscribeConfirmPost>>>
    export type ConfirmResubscriptionV1SubscriptionsResubscribeConfirmPostMutationBody = ConfirmResubscribeRequest
    export type ConfirmResubscriptionV1SubscriptionsResubscribeConfirmPostMutationError = HTTPValidationError

    /**
 * @summary Confirm Resubscription
 */
export const useConfirmResubscriptionV1SubscriptionsResubscribeConfirmPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmResubscriptionV1SubscriptionsResubscribeConfirmPost>>, TError,{data: ConfirmResubscribeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmResubscriptionV1SubscriptionsResubscribeConfirmPost>>,
        TError,
        {data: ConfirmResubscribeRequest},
        TContext
      > => {

      const mutationOptions = getConfirmResubscriptionV1SubscriptionsResubscribeConfirmPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    